import React from "react";
import AddButton from "components/ui/Button/AddButton/AddButton";
import { postFormActionTypes } from "../../enums";
import { POST_FORM_WORKFLOW_UPDATE_PERMISSION } from "../../../PostForms/permissions";
import { CANNED_RESPONSE_CREATE_PERMISSION } from "../../../CannedResponses/permissions";
import { Dropdown } from "components/ui";

const { ADD_POST_FORM_BRANCH, ADD_CANNED_RESPONSE } = postFormActionTypes;

const FormsPFBranchesActionDropdownAddButton = ({
    referenceData,
    handleRowAction,
}) => {
    return (
        <Dropdown
            size='sm'
            placeholder={
                <AddButton
                    btnText={"Add Item"}
                    otherClassName='justify-content-end me-1'
                />
            }
            ddValueClass='borderless'
            className='table__dropdown'
            ddOptionsClass='table__dropdown'
            anchor={false}
            changeValue={false}
            onChange={({ value }) => handleRowAction(value, referenceData)}
            options={[
                {
                    label: "Add Collection",
                    value: ADD_POST_FORM_BRANCH,
                    baseResources: POST_FORM_WORKFLOW_UPDATE_PERMISSION,
                },
                {
                    label: "Add Canned Response",
                    value: ADD_CANNED_RESPONSE,
                    baseResources: CANNED_RESPONSE_CREATE_PERMISSION,
                },
            ]}
        />
    );
};

export default FormsPFBranchesActionDropdownAddButton;
